import React from 'react';
import ErrorMessage from 'src/shared/components/error-msg/ErrorMessage';
import styles from './ListOfErrors.module.scss';

export type ListOfErrorsProps = {
    errors: string[];
    className?: string;
};

export const ListOfErrors = ({ errors, className }: ListOfErrorsProps) => {
    if (errors.length === 0) {
        return null;
    }

    return (
        <div className={`${styles.listOfErrors} ${className || ''}`}>
            {errors.map((error, index) => (
                <ErrorMessage key={index} message={error} />
            ))}
        </div>
    );
};

export default ListOfErrors;
